import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
const videoUrl = process.env.REACT_APP_VIDEO_LANDING_URL;

export default function LandingSection() {
  const { t } = useTranslation();

  // Animation variants for text
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut", delay: 0.2 },
    },
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src={videoUrl} type="video/mp4" />
        {t("Your browser does not support the video tag.")}
      </video>

      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-black/50 z-10"></div>

      {/* Text Content */}
      <div className="relative z-20 text-center text-white px-4">
        <motion.h1
          className="text-5xl md:text-7xl font-bold mb-4 leading-tight"
          variants={textVariants}
          initial="hidden"
          animate="visible"
        >
          {t("Your trusted")}
          <br />
          {t("UAE Business Partner")}
        </motion.h1>
        <motion.p
          className="text-lg md:text-xl max-w-2xl mx-auto mb-8 text-gray-200"
          variants={textVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.4 }}
        >
          {t(
            "A boutique firm of young professionals helping companies maximize results and minimize risks"
          )}
        </motion.p>
        <Link
          to="/services"
          className="inline-block py-3 px-6 bg-[#3896BE] text-white font-semibold rounded-md hover:bg-[#2a7a9b] transition-colors duration-300"
          variants={textVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.6 }}
        >
          {t("Explore Our Services")}
        </Link>
      </div>
    </section>
  );
}
